import { JuiceboxCaseStudy } from '../../components/customers/JuiceboxCaseStudy';

export default function CaseStudySlugPage({ slug }) {
  if (slug === 'juicebox') {
    return <JuiceboxCaseStudy />;
  }
}


export async function getStaticPaths() {
  return {
    paths: [
      { params: { slug: 'juicebox' } },
    ],
    fallback: false,
  };
}


export async function getStaticProps({ params }) {
  return {
    props: {
      slug: params.slug,
    },
  };
}
